import { centsToEur } from './currency.utils';

/**
 * Format an amount (in EUR) for display.
 * Use formatCurrencyFromCents when the value is in cents (e.g. from API).
 */
export function formatCurrency(
  // The body has always handled both: `amount == null` is the first thing it
  // tests. The signature said number, so the two specs covering that behaviour
  // had to assert their way past it.
  amount: number | null | undefined,
  currency = 'EUR',
): string {
  if (amount == null || isNaN(amount)) {
    return '';
  }
  const roundedAmount = Math.round(amount * 100) / 100;
  if (currency === 'EUR') {
    const formatted = roundedAmount.toFixed(2).replace('.', ',');
    return `${formatted} €`;
  }
  if (currency === 'USD') {
    const formatted = roundedAmount.toFixed(2);
    return `$${formatted}`;
  }
  const formatted = roundedAmount.toFixed(2);
  return `${formatted} ${currency}`;
}

/**
 * Format an amount in cents for display (converts to EUR then formats).
 * Use for all UI display when the value comes from API or is stored in cents.
 */
export function formatCurrencyFromCents(cents: number | undefined | null, currency = 'EUR'): string {
  return formatCurrency(centsToEur(cents), currency);
}
